// src/js/echo.js
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

window.Pusher = Pusher

const echo = new Echo({
  broadcaster: 'pusher',
  key: import.meta.env.VITE_PUSHER_APP_KEY,
  cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
  wsHost: window.location.hostname,
//   wsPort: 6001,
  wssPort: 6001,
  forceTLS: true,
  enabledTransports: ['ws', 'wss'],
  encrypted: true,
})

export default echo
